<template>
  <b-modal
    @ok="onClickOk"
    id="multiAllocationModal"
    title="Mehrere KKE einer VE zuweisen"
    @show="loadAllocationUnitsSimple"
  >
    <div class="mb-3">Bitte wählen Sie eine Vergabeeinheit, der die KKE Budgets zugewiesen werden sollen.</div>
    <b-list-group style="height:514px;overflow-y:auto">
      <b-list-group-item
        href="#"
        :active="item.DbId == currentSelectedItemId"
        class="flex-column align-items-start"
        v-for="item in items"
        :key="item.DbId"
        @click="selectItem(item)"
        @dblclick.stop="selectItemAndClose(item)"
      >
        <div style="display:inline-block;width:80px" class="text-muted">{{ item.Ordinal }}</div>
        {{ item.DisplayName }}
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
//import projectStore from '@/store/Projects';
//import settingsStore from '@/store/Settings';
import allocationUnitsService from '@/service/AllocationUnitsService';
//import budgetService from '@/service/BudgetService';
//import AppState from '@/store/App.js';

export default {
  emits: ['ok'],
  data() {
    return {
      items: [],
      currentSelectedItemId: null
    };
  },
  methods: {
    loadAllocationUnitsSimple() {
      allocationUnitsService
        .getAllocationUnitsSimple()
        .then(items => (this.items = items))
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    selectItem(item) {
      this.currentSelectedItemId = item.DbId;
    },
    selectItemAndClose() {},
    onClickOk() {
      this.$emit('ok', this.currentSelectedItemId);
    }
  }
};
</script>

<style></style>
